
const getUrlBase = function () {
  const origin = location.hostname // 当前访问域名
  const result = {
    eduBaseUrl: '',
    userBaseUrl: ''
  }
  if (process.env.NODE_ENV === 'development') {
    result.eduBaseUrl = process.env.VUE_APP_BASE_API
    result.userBaseUrl = process.env.VUE_APP_BASE_USER_API
    console.log('local urlBase: ', result)
  } else {
    if (origin.indexOf('foreign') > -1) {
      result.eduBaseUrl = process.env.VUE_APP_BASE_API_MASTER_FOREIGN
      result.userBaseUrl = process.env.VUE_APP_BASE_USER_API_MASTER_FOREIGN
      console.log('master-foreign urlBase: ', result)
    } else if (origin.indexOf('foreign-testserver') > -1) {
      result.eduBaseUrl = process.env.VUE_APP_BASE_API_DEV_FOREIGN
      result.userBaseUrl = process.env.VUE_APP_BASE_USER_API_FOREIGN
      console.log('test-foreign urlBase: ', result)
    } else if (origin.indexOf('-testserver') > -1) {
      result.eduBaseUrl = process.env.VUE_APP_BASE_API_DEV
      result.userBaseUrl = process.env.VUE_APP_BASE_USER_API_DEV
      console.log('test urlBase: ', result)
    } else {
      result.eduBaseUrl = process.env.VUE_APP_BASE_API_MASTER
      result.userBaseUrl = process.env.VUE_APP_BASE_USER_API_MASTER
      console.log('master urlBase: ', result)
    }
  }

  return result
}
export default getUrlBase()
